module.exports = __webpack_public_path__ + "img/mittagsmenuetellerohnehintergrund.451ec728.png";